export default __webpack_public_path__ + "static/media/UniSansHeavy.de76b172.otf";